import $ from "jquery";

const alert = {
  TYPE_SUCCESS: "success",
  TYPE_ERROR: "error",

  /**
   * Build alert to insert into the DOM
   * @return {object}
   */
  buildAlert() {
    const $alert = $("<div>").addClass("alert");
    $alert.append($("<strong>").addClass("alert__title"));
    $alert.append($("<p>").addClass("alert__message"));
    $alert.append($("<a>").addClass("alert__close icon-cancel"));
    return $alert;
  },

  /**
   * Return title for alert based on type
   * @param  {string} alertType
   * @return {string}
   */
  getTitle(alertType) {
    if (alertType === this.TYPE_SUCCESS) {
      return "Success!";
    }
    return "There was a problem!";
  },

  /**
   * Show an alert. Only one per page, so if one exists already in the DOM, we'll
   * replace the contents. Otherwise build a new one.
   *
   * @param  {string} message
   * @param  {string|null} alertType
   */
  show(message, alertType) {
    const self = this;
    const type = alertType || this.TYPE_SUCCESS;
    let $alert = $(".alert");
    if (!$alert.length) {
      $alert = this.buildAlert();
      $alert.prependTo($(".page .page__content")).hide();
    }
    $alert.find(".alert__title").html(this.getTitle(type));
    $alert.find(".alert__message").html(message);
    $alert.fadeIn();

    $alert.find(".alert__close").one("click", self.hide.bind(self));
  },

  /**
   * Hide alert
   */
  hide() {
    const $alert = $(".alert");
    if ($alert.length) {
      $alert.hide();
    }
  },
};

export default alert;
